import { createContext, useContext } from 'react'

import type { PortalPublic } from '@/apis/portalTypes'

export interface PortalContextValue {
    portal: PortalPublic
    /** '' on a custom domain, '/portal/<slug>' on the dashboard host. */
    basePath: string
}

export const PortalContext = createContext<PortalContextValue | null>(null)

export function usePortal(): PortalContextValue {
    const v = useContext(PortalContext)
    if (!v) {
        throw new Error('usePortal() outside <PortalRoot>')
    }
    return v
}

/** Absolute path inside the portal ('' base → '/login'). */
export function portalPath(basePath: string, sub = ''): string {
    const s = sub.replace(/^\/+/, '')
    return `${basePath}/${s}`
}
